import { GET_REPORT_TITLES, GET_SSWP_CONFIGS, GET_HSQE_CONFIGS } from "./types";

const INITIAL_STATE = {
    requesting: false,
    reportTitles: false,
    sswpConfigs: false,
    hsqeConfigs: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_REPORT_TITLES.REQUEST: {
            return { ...state, requesting: true, reportTitles: false };
        }
        case GET_REPORT_TITLES.FAIL: {
            return { ...state, requesting: false, reportTitles: false };
        }
        case GET_REPORT_TITLES.SUCCESS: {
            return {
                ...state,
                requesting: false,
                reportTitles: action.payload
            };
        }
        case GET_SSWP_CONFIGS.REQUEST: {
            return { ...state, requesting: true, sswpConfigs: false };
        }
        case GET_SSWP_CONFIGS.FAIL: {
            return { ...state, requesting: false, sswpConfigs: false };
        }
        case GET_SSWP_CONFIGS.SUCCESS: {
            return { ...state, requesting: false, sswpConfigs: action.payload };
        }
        case GET_HSQE_CONFIGS.REQUEST: {
            return { ...state, requesting: true, hsqeConfigs: false };
        }
        case GET_HSQE_CONFIGS.FAIL: {
            return { ...state, requesting: false, hsqeConfigs: false };
        }
        case GET_HSQE_CONFIGS.SUCCESS: {
            return { ...state, requesting: false, hsqeConfigs: action.payload };
        }
        default: {
            return { ...state };
        }
    }
};
